import moment from 'moment';
import { Vue, Component } from 'vue-property-decorator';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import WokForms from 'wok-forms';
import WokCharts from 'wok-charts';

// Import moment l10n.

import 'moment/locale/it';

// Before anything else, register hooks.

Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteUpdate',
    'beforeRouteLeave'
]);

// Add global components.

import LoadingSpinner from '../dndg/components/spinner.vue';

Vue.component('loading-spinner', LoadingSpinner);

// Add common filters for all Vue components. Also make some of the filters
// available as method on all Vue instances.

import filters from '../global/filters';
Vue.mixin({
    filters
});

// Setup store, routing and application.

import OPTIONS from './store';
import AppWrapper from '../dndg/components/app-wrapper.vue';
import { initRoutes, routeParams, homeRouteName } from './routes';
import { initDetector } from '../dndg/helpers/detector';
import * as messages from './i18n-defaults.json';

async function init(element: HTMLElement) {
    Vue.use(Vuex);
    Vue.use(VueRouter);
    Vue.use(VueI18n);
    Vue.use(WokForms);
    Vue.use(WokCharts);

    var store = new Vuex.Store(OPTIONS);
    var router = new VueRouter({
        routes: initRoutes(store),
        mode: 'history',
        scrollBehavior: function(to, from, savedPosition) {
            if (to.hash) {
                return { selector: to.hash }
            }
            else if (savedPosition) {
                return savedPosition
            }
            else {
                return { x: 0, y: 0 }
            }
        }
    });

    router.beforeEach(async (to, from, next) => {
        async function check() {
            var response = await store.dispatch('authenticationCheck');
            return response.result == "OK";
        }

        
        if (!/signup/.test(to.name) && !/privacy-policy/.test(to.name) && !/about/.test(to.name) && to.name != 'repubblica-landing' && to.name != 'survey-landing') {
            if (!store.state.isAuthenticated && !(await check())) {
                next({ name: 'signup', params: routeParams(to) });
                return;
            }

            // If the user never registered send it to the registration page.
            /* if (!store.state.loggedUser.isRegistered && (!/register/.test(to.name) && !/privacy-policy/.test(to.name) && !/about/.test(to.name))) {
                next({ name: 'register', params: routeParams(to) });
                return;
            } */
        }

        next();
    });

    router.afterEach((to, from) => {
        store.commit('resetUI');
    });

    initDetector((level) => {
        store.commit('setMobile', level >= 1);
    });

    var i18n = new VueI18n({
        messages: messages,
        fallbackLocale: 'it'
    });

    new Vue({
        el: element,
        i18n,
        store,
        router,
        components: {
            'dndg-app': AppWrapper
        }
    });
}

window.addEventListener('load', function () {
    let app = document.getElementById('application');
    if (app != null) {
        init(app);
    }
});


// WEBPACK FOOTER //
// ./src/app/main.ts